import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSaBia from './sa-bia.reducer';
import { SaBiaState } from './sa-bia.state';

export const selectBiaState = createFeatureSelector<SaBiaState>(
  fromSaBia.saBiaFeatureKey
);

export const getImpactTemplates = createSelector(
  selectBiaState,
  (state) => state.impactTemplates
);

export const getITGroups = createSelector(
  selectBiaState,
  (state) => state.iTGroups
);

export const getITGroupsLoaded = createSelector(selectBiaState, (state) => ({
  maos: state.maos,
  rtos: state.rtos,
  impactTypes: state.impactTypes,
  impactValues: state.impactValues,
  impactTemplates: state.impactTemplates,
}));

export const getITGroupsByTemplate = createSelector(
  getITGroups,
  (state, action) =>
    state.filter((itg) => itg.saImpactTemplate.id === action.id)
);

export const getImpactTypes = createSelector(
  selectBiaState,
  (state) => state.impactTypes
);

export const getImpactValues = createSelector(
  selectBiaState,
  (state) => state.impactValues
);

export const getMaos = createSelector(selectBiaState, (state) => state.maos);

export const getRtos = createSelector(selectBiaState, (state) => state.rtos);

export const getRaInQues = createSelector(
  selectBiaState,
  (state) => state.raIntQues
);

export const getCriticalDef = createSelector(
  selectBiaState,
  (state) => state.criticalDef
);
export const getSaBiaIntro = createSelector(
  selectBiaState,
  (state) => state.saBiaIntro
);
